import { AnyNotificationContext } from "../components/Notifications";

export const selectorPayerIdFromContext = (
  context: AnyNotificationContext
): string | undefined => {
  if (!context) {
    return undefined;
  }

  if ("payer" in context && context.payer?.payerId) {
    return context.payer.payerId;
  }

  // TODO: fix after remove all of that on BE
  // @ts-ignore
  return context.client?.clientId;
};
